import { SVButton, SVLoader } from '@/components/core';
import DefaultLayout from '@/components/layouts/DefaultLayout';
import WireRecipientDetailsBankInfo from '@/components/wireRecipients/details/WireRecipientDetailsBankInfo';
import WireRecipientDetailsInfo from '@/components/wireRecipients/details/WireRecipientDetailsInfo';
import WireRecipientDeleteCancelDialog from '@/components/wireRecipients/WireRecipientDeleteCancelDialog';
import { ROUTES } from '@/constants/routes';
import { useGetCustomerDetails } from '@/hooks/requests/useCustomers';
import { useGetWireRecipientDetails } from '@/hooks/requests/useWireRecipients';
import { Card, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { useParams } from 'react-router-dom';

export default function WireRecipientsDetailsPage() {
  const [open, setOpen] = useState(false);
  const { customerId = '', uuid = '' } = useParams();
  const { customerDetails, isCustomerDetailsPending } =
    useGetCustomerDetails(customerId);
  const { wireRecipientDetails, isWireRecipientDetailsPending } =
    useGetWireRecipientDetails(uuid);

  if (isWireRecipientDetailsPending || isCustomerDetailsPending) {
    return (
      <DefaultLayout header="Wire Recipient">
        <SVLoader />
      </DefaultLayout>
    );
  }

  if (!wireRecipientDetails || !customerDetails) {
    return (
      <DefaultLayout header="Wire Recipient">
        <Card>
          <Typography>
            Something went wrong retreiving the wire recipient. Our team has
            been notified.
          </Typography>
        </Card>
      </DefaultLayout>
    );
  }

  const { firstName, lastName } = customerDetails;
  const { recipientNickName, status } = wireRecipientDetails;

  return (
    <DefaultLayout
      header={recipientNickName}
      breadcrumb={[
        { label: 'Customers', href: ROUTES.CUSTOMERS },
        {
          label: `${firstName} ${lastName}`,
          href: `${ROUTES.CUSTOMERS}/${customerId}`,
        },
        {
          label: 'Wire Recipients',
          href: `${ROUTES.CUSTOMERS}/${customerId}${ROUTES.WIRE_RECIPIENTS}`,
        },
        { label: recipientNickName, isActive: true },
      ]}
      buttons={
        status === 'active'
          ? [
              <SVButton
                onClick={() => setOpen(true)}
                key="delete"
                variant="error">
                Delete
              </SVButton>,
            ]
          : []
      }>
      <Stack spacing={2}>
        <WireRecipientDetailsInfo wireRecipientInfo={wireRecipientDetails} />
        <WireRecipientDetailsBankInfo bankInfo={wireRecipientDetails} />
      </Stack>
      <WireRecipientDeleteCancelDialog
        uuid={uuid}
        name={recipientNickName}
        isDelete
        open={open}
        setOpen={setOpen}
      />
    </DefaultLayout>
  );
}
